import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Send, Gift } from "lucide-react";

const TABS = [
  { to: "/vendor/messages", label: "Messaggi inviati", icon: Send, testid: "tab-sent" },
  { to: "/vendor/messages/loyalty", label: "Messaggi Fedeltà", icon: Gift, testid: "tab-loyalty" },
];

export default function MessagesTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="flex gap-1 p-1 bg-slate-100 rounded-2xl" data-testid="messages-tabs">
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = t.to === "/vendor/messages" ? pathname === "/vendor/messages" : pathname.startsWith(t.to);
        return (
          <button key={t.to} onClick={() => navigate(t.to)} data-testid={t.testid}
            className={`flex-1 flex items-center justify-center gap-2 h-11 rounded-xl font-bold text-sm transition ${
              active ? "bg-white text-[#E63946] shadow-sm" : "text-slate-500 hover:text-slate-700"
            }`}>
            <Icon className="h-4 w-4" /> {t.label}
          </button>
        );
      })}
    </div>
  );
}
